import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './LogoItem.css'
import template from './LogoItem.jinja'

var LogoItem = Backbone.View.extend({
    initialize () {
    }
})

export default LogoItem


// WEBPACK FOOTER //
// ./assets/app/front/components/LogoItem/LogoItem.js